// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Types --------------------------------------------------------------------------------------
export type TyFact = { key: string; label: string; value: string; ltr?: boolean };

type Props = { facts: TyFact[] };
// --- Logic --------------------------------------------------------------------------------------
/**
 * A record's own fields, read rather than filled. Label at the start, answer at the far end, so the
 * labels are the column you scan.
 *
 * **Only what somebody filled in** — the screens drop the empty ones before passing them here. A grid
 * of em-dashes is a full page that says nothing, and a blank is already visible where it belongs, in
 * the edit form.
 *
 * `ltr` is for the values that read left to right in both languages: a phone number, a slug, a
 * registry number, an ISO date.
 */
export default function FactsGrid({ facts }: Props) {
    if (!facts.length) return null;

    return (
        <div className="facts-grid">
            {facts.map((fact) => (
                <div key={fact.key} className="facts-grid__fact">
                    <span className="facts-grid__label">{fact.label}</span>
                    <span className={`facts-grid__value${fact.ltr ? " facts-grid__value--ltr" : ""}`}>{fact.value}</span>
                </div>
            ))}
        </div>
    );
}
